import { serializeLegacyIndustryCode } from '../../../../../api/serializers/industry-code.serializers';
import {
  ServiceHandler,
  serializeStandardResponse,
} from '../../../../../utils';
import {
  deserializeStandardResponse,
  formatP100Coverages,
  transformP100CoverageValuesResponse,
} from './transformers';
import type {
  P100PricingPayload,
  CalculateP100RateResponse,
  BoostRaterVersionPayload,
  BoostRaterVersionResponse,
  GetPrime100CoveragesResponse,
  QuoteCartListResponse,
  SocialEngineeringResponse,
  TransformedEligibleCoverageValuesResponse,
  UpdateSocialEngineeringPayload,
  UpdateSocialEngineeringResponse,
  AddQuoteToCartRequest,
  AddQuoteToCartResponse,
  CartItem,
  BulkRequestQuotesRequest,
  Prime100QuoteDetailsResponse,
  EditPrime100QuoteRequest,
  Prime100PolicyDetailsResponse,
  RequestQuoteRequest,
  RateRequest,
} from './types';

export const getQuoteCartList = ServiceHandler<unknown, QuoteCartListResponse>({
  url: '/api/quote/v1/calculator/account/:accountId',
});

export const getP100EligibleCoverageValues = ServiceHandler<
  unknown,
  TransformedEligibleCoverageValuesResponse
>({
  url: '/api/quote/v1/eligibility',
  transformResponse: [
    serializeStandardResponse,
    transformP100CoverageValuesResponse,
  ],
});

export const getSocialEngineering = ServiceHandler<
  unknown,
  SocialEngineeringResponse
>({
  url: '/api/account/v1/account/profile/socialEngineering/:accountId',
});

export const updateSocialEngineering = ServiceHandler<
  UpdateSocialEngineeringPayload,
  UpdateSocialEngineeringResponse
>({
  url: '/api/account/v1/account/profile/socialEngineering',
  method: 'PUT',
});

export const getBoostRaterVersion = ServiceHandler<
  BoostRaterVersionPayload,
  BoostRaterVersionResponse
>({
  url: '/api/quote/v1/boost-rater-version',
  method: 'POST',
});

export const getPrime100Coverages = ServiceHandler<
  unknown,
  GetPrime100CoveragesResponse
>({
  url: '/api/account/v1/state/p100',
});

export const calculateP100Rate = ServiceHandler<
  RateRequest,
  CalculateP100RateResponse
>({
  url: '/api/quote/v1/rates',
  method: 'POST',
});

export const addQuoteToCart = ServiceHandler<
  AddQuoteToCartRequest,
  AddQuoteToCartResponse
>({
  url: '/api/quote/v1/calculator',
  method: 'POST',
});

export const deleteQuoteFromCart = ServiceHandler<unknown, CartItem>({
  url: '/api/quote/v1/calculator/:quoteId?agencyId=:agencyId',
  method: 'DELETE',
});

export const bulkRequestQuotes = ServiceHandler<
  BulkRequestQuotesRequest,
  unknown
>({
  url: '/api/quote/v1/bulk',
  method: 'POST',
});

/* edit quote */
export const getP100QuoteDetails = ServiceHandler<
  unknown,
  Prime100QuoteDetailsResponse
>({
  url: '/api/quote/v1/:quoteId',
  transformResponse: [
    serializeStandardResponse,
    serializeLegacyIndustryCode,
    formatP100Coverages,
  ],
});

export const editPrime100Quote = ServiceHandler<
  EditPrime100QuoteRequest,
  unknown
>({
  url: '/api/quote/v1/edit/:quoteId',
  method: 'PUT',
});

export const getP100PolicyDetails = ServiceHandler<
  unknown,
  Prime100PolicyDetailsResponse
>({
  url: '/api/policy/v1/:policyId',
  transformResponse: [
    serializeStandardResponse,
    serializeLegacyIndustryCode,
    deserializeStandardResponse,
  ],
});

export const getP100BasePolicyDetails = ServiceHandler({
  url: 'api/policy/v1/P100/endorsement/original/:policyNumber',
});

export const requestQuote = ServiceHandler<RequestQuoteRequest, unknown>({
  url: '/api/quote/v1/:accountId',
  method: 'POST',
});

export const getLatestPolicyDetails = ServiceHandler({
  url: '/api/policy/v1/P100/endorsement/latest/:policyNumber',
});
